(() => {
  const namespace = "team-carousel";
  const parent = document.getElementById(namespace);
  const items = parent.querySelectorAll(`[id^="${namespace}"]`);

  if (!parent || !items) { return; }

  const createIntersectionObserver = (element, callback, options) => {
    let observer = new IntersectionObserver(callback, options);
    observer.observe(element);
    return observer;
  }

  const persistentCallback = (entries, observer) => {
    entries.forEach(entry => {
      entry.target.setAttribute('aria-hidden', !entry.isIntersecting);

      let previousElementSibling = entry.target.previousElementSibling;
      let nextElementSibling = entry.target.nextElementSibling;

      if (previousElementSibling) {
        createIntersectionObserver(previousElementSibling, temporaryCallback, options);
      }

      if (nextElementSibling) {
        createIntersectionObserver(nextElementSibling, temporaryCallback, options);
      }
    });
  }

  const temporaryCallback = (entries, observer) => {
    entries.forEach(entry => {
      entry.target.setAttribute('aria-hidden', !entry.isIntersecting);
      observer.unobserve(entry.target);
    });
  }

  const options = {
    root: parent,
    rootMargin: "20px",
    threshold: 1.0,
  }

  items.forEach((item) => {
    createIntersectionObserver(item, persistentCallback, options);
  });
})();
